import React, { useState } from 'react';
import { Link } from "react-router-dom";
import Icon from '@mui/material/Icon';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';

import ChevronDownIcon from '@mui/icons-material/ExpandMore';
import ChevronUpIcon from '@mui/icons-material/ExpandLess';
import MegaMenu from "components/Home/child-components/MegaMenu";
import {Container, AppBar, Toolbar,  Link as MUILink} from '@mui/material';
import MDBox from "dashboard/components/MDBox";

const isIcon = icon => icon && icon.name ;

const ancerX = {
  exit:{
    y:4,
    x:5
  },
  open:{
    opacity:1, 
    x : 5, 
    transition: {
      type: "spring",
      duration: 0.4
    }
  },

}

const NavigationMenu = (props) => {
	const {  data, darkMode, limit } = props;
  const [item, setItem] = useState(null);
  const [open, setOpen] = useState(false); 
  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };


  
  const handleMouseEnterControls = (event,item, index) =>{
    event.preventDefault();
    setValue(index);
    setItem(item);
    // ancerX.open.x = Math.round(e.target.offsetLeft + e.target.offsetWidth/2 ) - e.target.parentElement.offsetLeft
    const clickedTabXPosition = event.currentTarget.getBoundingClientRect().x;
    ancerX.open.x = clickedTabXPosition -  Math.round(event.target.offsetWidth < 210 ? event.target.offsetWidth/2 : event.target.offsetWidth/4 )
    setOpen(true)
  }

  return (
    <AppBar id="megaTabsMenu" position="static" component="nav">
        <Toolbar className="navbar-default" sx={{
            p:".25rem !important", 
            backgroundImage: ({ functions: { linearGradient, rgba }, palette: { gradients } }) =>
            `${linearGradient(
              darkMode ? "#121212":"#f7f7f7",
              darkMode ? "#1b1b1b": "#ffffff",
              180
            )}`,
           minHeight:"60px !important",
           
           }}>
          {data && 
          <Container sx={{display:"flex", alignItems:"center", justifyContent:"space-between", px : {xs:0, lg : 2 }}}  maxWidth="sm">
          <MDBox sx={{ 
                maxWidth: { xs: "calc(100vw - 10px)", md : '100%' }, 
                "& .MuiTabs-root" : {backgroundColor: 'transparent !important'}, 
                "& .MuiTypography-body2, .MuiLink-underlineNone":{fontSize:"0.9rem !important"},
                 "& .MuiTabs-indicator" : {maxHeight: "calc(100% - 8px)", top :5, bottom : "auto", opacity : value === null ? 0 : 1 },
                 "& .MuiTabs-scroller" : {p : .5 },
                 "& .MuiTabScrollButton-root" : {
                  display :  "inline-flex !important",
                  width:30
                }
              }}
                
                >
              <Tabs
                value={value}
                onChange={handleChange}
                variant="scrollable"
                scrollButtons="auto"
                allowScrollButtonsMobile
                aria-label="scrollable auto tabs"
                role="navigation"
              >
                
                {data.content.map( (item, index) => item.active === 1 &&  (
                    item.children && item.children.length > 0 ?
                        <MUILink 
                          className="mega-menu-with-children"
                          key={`link-b-${item.id}`}
                          sx={{ textAlign: 'center', cursor:"pointer" ,display: "flex" ,alignItems: "center" , py:1, px : 2, "&:hover":{color:"#23346a"}}}
                          component={Link}  
                          onClick={e=>handleMouseEnterControls(e,item, index)}
                           >
                            {isIcon(item.icon) && <Icon sx={{ mr:1}}>{item.icon.name}</Icon>} {item.title} {open && index === value ? <ChevronUpIcon /> : <ChevronDownIcon  />}
                        </MUILink>               
                        : <MUILink key={`link-b-${item.id}`} sx={{ textAlign: 'center', cursor:"pointer" ,display: "flex" ,alignItems: "center" , py:1, px : 2, "&:hover":{color:"#23346a"}}} component={Link} to={`${item.link?.slug}`} >{item.icon && <Icon sx={{mr:1}}>{item.icon.name}</Icon>} {item.title}</MUILink>
                  ))}
              </Tabs>
              <MegaMenu limit={limit} item={item} darkMode={darkMode} open={open} setOpen={setOpen} ancerX={ancerX} />
            </MDBox>    
          </Container>}
      </Toolbar>
      
    </AppBar>
    
  );
}

export default NavigationMenu;

function samePageLinkNavigation(event) {
  if (
    event.defaultPrevented ||
    event.button !== 0 || // ignore everything but left-click
    event.metaKey ||
    event.ctrlKey ||
    event.altKey ||
    event.shiftKey
  ) {
    return false;
  }
  return true;
}

function LinkTab(props) {
  return (
    <Tab
      component="a"
      onClick={(event) => {
        // Routing libraries handle this, you can remove the onClick handle when using them.
        if (samePageLinkNavigation(event)) {
          event.preventDefault();
        }
      }}
      aria-current={props.selected && 'page'}
      {...props}
    />
  );
}